import request from '@/utils/request'

export function getTemplateFileUrl(templateId) {
  return request({
    url: `/api/template/downloadUrl/${templateId}`,
    method: 'get'
  })
}

// OnlyOffice保存回调接口（如需）
export function saveTemplateFile(templateId, data) {
  return request({
    url: `/api/template/onlyoffice-callback/${templateId}`,
    method: 'post',
    data
  })
} 